import React from 'react';
import Heading from '@havenengineering/module-shared-library/dist/components/Heading';
import AvailabilityIndicator from '@havenengineering/module-shared-library/dist/components/AvailabilityIndicator/AvailabilityIndicator';
import { gradeThresholds } from '@havenengineering/module-shared-library/dist/components/AvailabilityIndicator/thresholds';
import classNames from 'classnames';

import styles from './card-header.module.scss';
import { Occupancy } from '../../type/types';
import { SelectRadioIndicator } from '../../../shared/component/select-radio-indicator/select-radio-indicator';

type Props = {
  grade: string;
  description?: string;
  size?: number | '';
  smallTitle?: boolean;
  occupancyData?: Occupancy;
  labelCallBack?: (value: string) => string;
  isSoldOut?: boolean;
  isActive?: boolean;
};

export const CardHeader = ({
  grade,
  description,
  size,
  smallTitle,
  occupancyData,
  labelCallBack,
  isSoldOut = false,
  isActive,
}: Props) => {
  const showOccupancyIndicator = !!occupancyData;
  return (
    <div className={styles.cardHeaderRoot}>
      <div className={styles.content}>
        <Heading
          level={3}
          scale={0}
          className={classNames(styles.title, { [styles.smallTitle]: smallTitle })}
        >
          <span className={styles.gradeTitle}>
            <SelectRadioIndicator soldOut={isSoldOut} active={isActive} />
            {grade}
          </span>
          {size && (
            <>
              {' '}
              <span className={styles.divider}>|</span>{' '}
              <span className={classNames(styles.size, { [styles.smallSubTitle]: smallTitle })}>
                {size} sq. ft.
              </span>
            </>
          )}
        </Heading>
        <div className={styles.occupancyIndicatorWrapper}>
          {showOccupancyIndicator ? (
            <AvailabilityIndicator
              occupancyData={{
                physicalUnits: occupancyData.physicalUnits || occupancyData.units,
                physicalUnitsRemaining:
                  occupancyData.physicalUnitsRemaining || occupancyData.remaining,
                physicalOccupancy: occupancyData.physicalOccupancy || occupancyData.percentage,
                nestedPhysicalUnits: occupancyData.nestedPhysicalUnits || occupancyData.nestedUnits,
                nestedPhysicalUnitsRemaining:
                  occupancyData.nestedPhysicalUnitsRemaining || occupancyData.nestedRemaining,
                nestedPhysicalOccupancy:
                  occupancyData.nestedPhysicalOccupancy || occupancyData.nestedPercentage,
                totalUnits: occupancyData.totalUnits,
                totalUnitsRemaining:
                  occupancyData.totalUnitsRemaining || occupancyData.totalRemaining,
                totalOccupancy: occupancyData.totalOccupancy || occupancyData.totalPercentage,
              }}
              thresholds={gradeThresholds}
              labelCallback={labelCallBack}
              includeNested
            />
          ) : null}
          {isSoldOut ? <span>Sold out</span> : null}
        </div>
      </div>
      {description && <div>{description}</div>}
    </div>
  );
};
